export const props = {
  isOwner: {
    type: Boolean,
    default: false
  }
}
